function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, forwardRef } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { Button, Card, Skeleton, notification, Drawer, Image, Row as ARow, Col as ACol } from "antd";
import Common from "../components/includes/Common";
import { BoxArrowInLeft } from "react-bootstrap-icons";
import Moment from "react-moment";
import moment from "moment";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CompanyVaSheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var company = _ref.company;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    candidates = _useState2[0],
    setCandidates = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    estimatedCount = _useState4[0],
    setEstimatedCount = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataLoading = _useState6[0],
    setDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    count = _useState8[0],
    setCount = _useState8[1];
  useEffect(function () {
    setDataLoading(true);
    axios.get(Common.baseApiUrl + "getcompanyvalist/" + Common.currentUser.id + "/" + company.id).then(function (response) {
      if (response.data.status == 200) {
        setCandidates(response.data.customers);
        setEstimatedCount(response.data.count);
      } else {
        notification.error({
          message: "Erreur!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: "printable",
    ref: ref,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: dataLoading ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(ARow, {
              children: [/*#__PURE__*/_jsx(ACol, {
                span: 5,
                children: /*#__PURE__*/_jsx(Image, {
                  src: "/drawables/emgl.png",
                  width: "190px",
                  preview: false
                })
              }), /*#__PURE__*/_jsx(ACol, {
                span: 16,
                offset: 3,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    padding: "8px",
                    borderRadius: "7px",
                    color: "#EEE",
                    background: "#A9675C",
                    clear: "both"
                  },
                  children: [/*#__PURE__*/_jsx("h2", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RAPPELS DE VISITES ANNUELLES"
                    })
                  }), /*#__PURE__*/_jsxs("span", {
                    children: ["SOCIETE : ", company.label]
                  }), /*#__PURE__*/_jsxs("div", {
                    children: ["Date : ", /*#__PURE__*/_jsx(Moment, {
                      format: "DD/MM/YYYY"
                    })]
                  })]
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
              responsive: true,
              bordered: true,
              striped: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {
                    children: "NOM"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "NUM. DOSSIER"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "TELEPHONE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "POSTE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "DATE DERNIERE VISIT."
                  }), /*#__PURE__*/_jsx("th", {
                    children: "DATE PROCHAINE VISIT."
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: candidates.map(function (c, index) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: index + 1
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.name
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.candidate_code
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.mobile_first
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.job
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Moment, {
                        date: c.created_at,
                        format: "DD/MM/YYYY"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      style: {
                        color: "#B83636"
                      },
                      children: /*#__PURE__*/_jsx(Moment, {
                        date: moment(c.created_at).add(360, "days"),
                        format: "DD/MM/YYYY"
                      })
                    })]
                  }, c.id);
                })
              })]
            })]
          })
        })
      })]
    })
  });
});
export default CompanyVaSheet;